import { Component } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-knowledge-base-button',
  templateUrl: './knowledge-base-button.component.html',
  styleUrls: ['./knowledge-base-button.component.scss'],
  animations: [
    trigger('slideIn', [
      state('hidden', style({
        transform: 'translateY(100px)',
        opacity: 0
      })),
      state('visible', style({
        transform: 'translateY(0)',
        opacity: 1
      })),
      transition('hidden => visible', animate('300ms ease-out')),
      transition('visible => hidden', animate('300ms ease-in'))
    ]),
    trigger('rotate', [
      state('open', style({
        transform: 'rotate(180deg)'
      })),
      state('closed', style({
        transform: 'rotate(0deg)'
      })),
      transition('open <=> closed', animate('300ms ease-in-out'))
    ])
  ]
})
export class KnowledgeBaseButtonComponent {
  isWidgetOpen = false;
  buttonState = 'visible';

  toggleWidget() {
    this.isWidgetOpen = !this.isWidgetOpen;
  }

  widgetClosed() {
    this.isWidgetOpen = false;
  }
}

